import type { TMessages } from '@/types/TMessages'

export const messages = {
  title: 'Заявка отправлена!',
  description: 'Ожидайте обратную связь по заявке в течение рабочего дня',
} satisfies TMessages
